import {
  call,
  takeLatest,
  put,
} from 'redux-saga/effects';
import { signIn } from '../user';
import {
  SIGN_IN_DETAILS,
} from '../actionTypes';
import api from '../../utils/services';
import sumoLogger from '../../Logger';

function* getUserDetails() {
  try {
    const data = yield call(api.signInDetails);
    yield put(signIn(data));
  } catch (error) {
    sumoLogger.log('No login details');
  }
}

export default function* loginInfoSaga() {
  yield takeLatest(SIGN_IN_DETAILS, getUserDetails);
}
